import { Icon } from "@mui/material";
import { UserContext } from "App";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useContext, useState } from "react";
import Swal from "sweetalert2";
import AppointmentsApi from "../../../../Classes/API/Appointments/AppointmentsApi";
import LinkAccSessToAppHourReq from "../../../../Classes/Models/Requests/Appointments/LinkAccSessToAppHourReq";
import SearchStringOrIntReq from "../../../../Classes/Models/Requests/SearchStringOrIntReq";
import AddFacilityModal from "./AddFacilityModal";
import AppHourCell2 from "./AppHourCell2";
import CreateAppointmentPopUp from "./CreateAppointmentPopUp";
import Loader from "layouts/loader/loader";
import AddTherapistToDay from "../../AppointmentDays/AppointmentDayDetails/AddTherapistToDay";
import CopyDayCard from "./CopyDayCard";
import MDInput from "components/MDInput";
import { LanguageContext } from "App";
import MDButton from "components/MDButton";
import PatientSuggestions from "./PatientSuggestions";
import RemoveTherapistFromDayReq from "../../../../Classes/Models/Requests/Appointments/RemoveTherapistFromDayReq";
import TherapistDetailsPopUp from "./TherapistDetailsPopUp";
import EvalPatientsModal from "./EvalPatientsModal";
import TherapistReorderModal from "./TherapistReorderModal";
import {
  setMiniSidenav,
  setTransparentSidenav,
  useMaterialUIController,
} from "context";
import DummySessionsModal from "./DummySessionsModal";
import "./AppDay.scss";
import {
  AddCircle,
  RemoveCircle,
  ZoomIn,
  ZoomOut,
  Delete,
  Warning,
} from "@mui/icons-material";

const AppDayTableSimple = ({
  AppDay,
  setAppDay,
  setIsLoaded,
  GetAppDayById,
  IsLoaded,
  setShowCopyDay,
  ShowCopyDay,
  setShowAddTherapist,
  ShowAddTherapist,
  checkedDays,
  DayPartitionNumber,
  setDayPartitionNumber,
  id,
}) => {
  const { state, search } = useLocation();
  const CurrentUser = useContext(UserContext);
  const { translations, switchLanguage } = useContext(LanguageContext);
  const navigate = useNavigate();

  // State management
  const [
    DayPartitionNumberRetrievedBefore1,
    setDayPartitionNumberRetrievedBefore1,
  ] = useState(false);
  const [
    DayPartitionNumberRetrievedBefore2,
    setDayPartitionNumberRetrievedBefore2,
  ] = useState(false);
  const [
    DayPartitionNumberRetrievedBefore3,
    setDayPartitionNumberRetrievedBefore3,
  ] = useState(false);
  const [ShowCreateAppointment, setShowCreateAppointment] = useState(false);
  const [SelectedAppHour, setSelectedAppHour] = useState({});
  const [FacilityAccSession, setFacilityAccSession] = useState({});
  const [ShowFacilityModal, setShowFacilityModal] = useState(false);
  const [ShowSideBar, setShowSideBar] = useState(false);
  const [MovingSession, _setMovingSession] = useState({});
  const [Reminders, setReminders] = useState([]);
  const [isInnerLoaded, setIsInnerLoaded] = useState(true);
  const [SearchString, setSearchString] = useState("");
  const [PatientsSearch, setPatientsSearch] = useState("");
  const [Patient, setPatient] = useState(null);
  const [TherapistSearch, setTherapistSearch] = useState("");
  const [Therapist, setTherapist] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(0.7);
  const [Height, setHeight] = useState(100);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [removingTherapist, setRemovingTherapist] = useState(null);
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [showEvalModal, setShowEvalModal] = useState(false);
  const [showDummyModal, setShowDummyModal] = useState(false);
  const [dummySessionsList, setDummySessionsList] = useState([]);
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
  const [controller, dispatch] = useMaterialUIController();

  const removeTherapistFromDay = async (therapistDay) => {
    if (removingTherapist) return;

    setRemovingTherapist(therapistDay.therapistId);

    try {
      // Check if therapist has any appointments
      const hasAppointments = therapistDay.getAppointmentHours.some(
        (appHour) =>
          appHour.getAppointments && appHour.getAppointments.length > 0,
      );

      if (hasAppointments) {
        await Swal.fire({
          title:
            translations.appointmentTableCannotRemoveTherapist ||
            "Cannot Remove Therapist",
          text:
            translations.appointmentTableTherapistHasAppointments ||
            "This therapist has active appointments and cannot be removed.",
          icon: "warning",
          confirmButtonText: "OK",
          confirmButtonColor: "#f39c12",
        });
        return;
      }

      const result = await Swal.fire({
        title:
          translations.appointmentTableConfirmRemoveTherapist ||
          "Remove Therapist?",
        html: `
          <div style="text-align: left; margin: 20px 0;">
            <p><strong>Therapist:</strong> ${therapistDay.therapistName}</p>
            <p><strong>Date:</strong> ${new Date(
              AppDay.dateDay,
            ).toLocaleDateString()}</p>
            <p style="color: #e74c3c; margin-top: 15px;">
              <i class="fas fa-exclamation-triangle"></i> 
              ${translations.appointmentTableConfirmRemoveTherapistText}
            </p>
          </div>
        `,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#e74c3c",
        cancelButtonColor: "#95a5a6",
        confirmButtonText: translations.appointmentTableYesRemove,
        cancelButtonText: translations.appointmentTableCancel,
        reverseButtons: true,
      });

      if (!result.isConfirmed) return;

      // Create request
      const removeReq = new RemoveTherapistFromDayReq();
      removeReq.dayId = AppDay.id;
      removeReq.therapistId = therapistDay.therapistId;

      const res =
        await AppointmentsApi.RemoveTherapistFromAppointmentDay(removeReq);

      if (res.status === "Success") {
        await Swal.fire({
          title: translations.appointmentTableTherapistRemoved,
          text: `${therapistDay.therapistName} has been successfully removed from this day.`,
          icon: "success",
          confirmButtonColor: "#27ae60",
          timer: 3000,
          timerProgressBar: true,
        });

        // Refresh the data
        setIsLoaded(false);
      } else {
        await Swal.fire({
          title: translations.appointmentTableFailedToRemove,
          text: res.message,
          icon: "error",
          confirmButtonColor: "#e74c3c",
        });
      }
    } catch (error) {
      console.error("Error removing therapist:", error);
      await Swal.fire({
        title: translations.appointmentTableError,
        text: translations.appointmentTableErrorRemovingTherapist,
        icon: "error",
        confirmButtonColor: "#e74c3c",
      });
    } finally {
      setRemovingTherapist(null);
    }
  };

  const toggleHeader = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleZoomIn = () => {
    setZoomLevel((prevZoom) => Math.min(prevZoom + 0.05, 0.9));
  };

  const handleZoomOut = () => {
    setZoomLevel((prevZoom) => Math.max(prevZoom - 0.05, 0.2));
  };

  useEffect(() => {
    if (IsLoaded && AppDay) {
      const queryParams = new URLSearchParams(search);
      const targetId = queryParams.get("targetId");

      if (targetId) {
        setTimeout(() => {
          const element = document.getElementById(targetId);
          if (element) {
            element.scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center",
            });

            element.style.outline = "3px solid #3560AD";
            element.style.transition = "outline 0.5s ease-in-out";

            setTimeout(() => {
              element.style.outline = "none";
            }, 3000);
          }
        }, 500);
      }
    }
  }, [IsLoaded, search]);
  useEffect(() => {
    if (AppDay?.id ?? "" != null) {
      GetDayReminders();
    }
  }, [AppDay]);

  useEffect(() => {
    if (DayPartitionNumber === 1) {
      setDayPartitionNumberRetrievedBefore1(true);
      setDayPartitionNumberRetrievedBefore2(false);
      setDayPartitionNumberRetrievedBefore3(false);
      GetAppDayById(AppDay.id, DayPartitionNumber);
      setIsInnerLoaded(false);
    }
    if (DayPartitionNumber === 2) {
      setDayPartitionNumberRetrievedBefore2(true);
      setDayPartitionNumberRetrievedBefore1(false);
      setDayPartitionNumberRetrievedBefore3(false);
      GetAppDayById(AppDay.id, DayPartitionNumber);
      setIsInnerLoaded(false);
    }
    if (DayPartitionNumber === 3) {
      setDayPartitionNumberRetrievedBefore3(true);
      setDayPartitionNumberRetrievedBefore1(false);
      setDayPartitionNumberRetrievedBefore2(false);
      GetAppDayById(AppDay.id, DayPartitionNumber);
      setIsInnerLoaded(false);
    }
  }, [DayPartitionNumber]);

  useEffect(() => {
    const allDummy = [];
    AppDay?.getTherapists?.forEach((t) => {
      t.getAppointmentHours?.forEach((h) => {
        if (h.getListedAccountingSessionsDummy?.length > 0) {
          h.getListedAccountingSessionsDummy.forEach((s) => {
            allDummy.push({
              ...s,
              therapistName: t.therapistName,
              time: h.hour,
            });
          });
        }
      });
    });
    setDummySessionsList(allDummy);
  }, [AppDay]);

  useEffect(() => {
    if (AppDay != null) {
      setIsInnerLoaded(true);
    }
  }, [AppDay]);

  const onSearch = async () => {
    Swal.fire({
      title: "Please wait",
      text: "Loading...",
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const searchString = SearchString.trim().toLowerCase();

    if (searchString === "") {
      await GetAppDayById(id, DayPartitionNumber);
      return;
    }

    const filteredTherapists = AppDay.getTherapists
      .map((therapist) => {
        const filteredHours = therapist.getAppointmentHours
          .map((hour) => {
            const filteredSessions = hour.getListedAccountingSessions.filter(
              (session) =>
                session.therapistName.toLowerCase().includes(searchString) ||
                session.sessionName.toLowerCase().includes(searchString) ||
                session.patientName.toLowerCase().includes(searchString),
            );

            return {
              ...hour,
              getListedAccountingSessions: filteredSessions,
            };
          })
          .filter((hour) => hour.getListedAccountingSessions.length > 0);

        return {
          ...therapist,
          getAppointmentHours: filteredHours,
        };
      })
      .filter((therapist) => therapist.getAppointmentHours.length > 0);

    const filteredAppDay = {
      ...AppDay,
      getTherapists: filteredTherapists,
    };

    setAppDay(filteredAppDay);
    Swal.hideLoading();
    Swal.close();
  };

  const GetDayReminders = async () => {
    if (!AppDay?.id) return;

    const req = new SearchStringOrIntReq();
    req.SearchInt = AppDay.id;

    const res = await AppointmentsApi.GetDayReminders(req);

    if (res.status === "Success") {
      setReminders(res.data);
    }
  };

  const setMovingSession = (accSession) => {
    _setMovingSession(accSession);
    Swal.fire({
      position: "top-end",
      icon: "info",
      text: "Session Id: " + accSession.id + " is selected to move",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  const PasteSession = async (appHour) => {
    const isCopyOperation = MovingSession.moveAction === "copy";

    Swal.fire({
      icon: "info",
      title: isCopyOperation ? "Copying Session..." : "Moving Session...",
      text: "This may take a few minutes...",
      didOpen: () => {
        Swal.showLoading();
      },
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 1200,
    });
    if (MovingSession.id == null) {
      return;
    }
    Swal.fire({
      icon: "info",
      title: "Moving Session...",
      text: "This may take a few minutes...",
      didOpen: () => {
        Swal.showLoading();
      },
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 1200,
    });

    const req = new LinkAccSessToAppHourReq(
      MovingSession.id,
      appHour.id,
      false,
      false,
    );
    req.moveAction = MovingSession.moveAction || "cut";
    if (MovingSession.isDummy) {
      req.isDummy = true;
      req.patientName = MovingSession.patientName;
      req.sessionName = MovingSession.sessionName;
    }
    const res =
      await AppointmentsApi.LinkAccountingSessionToAppointmentHour(req);
    if (res.status === "Success") {
      Swal.fire({
        title: "Success",
        text: "Re-fetching data...",
        didOpen: () => {
          Swal.showLoading();
        },
        icon: "success",
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 1200,
      });
      _setMovingSession({});
      const res2 = await GetAppDayById(AppDay.id, DayPartitionNumber);
      if (res2.status === "Success") {
        Swal.fire({
          title: "Success",
          text: res.message,
          icon: "success",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 1200,
        });
        GetAppDayById(AppDay.id);
      } else {
        Swal.fire({
          title: "Failed",
          text: res.message,
          icon: "error",
        });
      }
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
      });
    }
  };

  useEffect(() => {
    const sideNav = document.getElementById("TheSidenav");
    if (ShowSideBar) {
      sideNav.style.display = "block";
      setMiniSidenav(dispatch, false);
      setTransparentSidenav(dispatch, false);
    } else {
      sideNav.style.display = "none";
      setMiniSidenav(dispatch, true);
      setTransparentSidenav(dispatch, true);
    }
    return () => {
      sideNav.style.display = "block";
    };
  }, [ShowSideBar]);

  const checkDays = async () => {
    let checkedDaysText = "";

    checkedDays.forEach((day, index) => {
      checkedDaysText += `<div style="text-align: left;"> Session ${
        index + 1
      }: <br> ${day}</div><br><br>`;
    });

    Swal.fire({
      icon: "info",
      title: "Checked Days Preview",
      html: checkedDaysText,
      allowOutsideClick: false,
    });
  };

  const ClearAppointmentDay = async () => {
    const confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, clear it!",
    });

    if (!confirmation.isConfirmed) {
      return;
    }

    Swal.fire({
      icon: "info",
      title: "Clearing Appointments...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const req = new SearchStringOrIntReq();
    req.SearchInt = AppDay.id;

    const res = await AppointmentsApi.ClearAppointmentDay(req);

    if (res.status === "Success") {
      Swal.fire("Success", res.message, "success");
      setIsLoaded(false);
      GetAppDayById(AppDay.id);
    } else {
      Swal.fire("Failed", res.message, "error");
    }
  };

  const handlePartitionChange = (newSlot) => {
    setDayPartitionNumber(newSlot);
    const queryParams = new URLSearchParams(search);
    queryParams.set("slot", newSlot);

    navigate(`?${queryParams.toString()}`, {
      replace: true,
      state: state,
    });
  };

  const GetDayPartitionButtons = () => {
    return (
      <div className="time-session-btn">
        <button
          className={
            DayPartitionNumber === 1
              ? "btn btn-sm btn-success"
              : "btn btn-sm btn-outline-secondary"
          }
          onClick={() => {
            handlePartitionChange(1);
          }}
        >
          00:00 - 07:00
        </button>
        <button
          className={
            DayPartitionNumber === 2
              ? "btn btn-sm btn-success"
              : "btn btn-sm btn-outline-secondary"
          }
          onClick={() => {
            handlePartitionChange(2);
          }}
        >
          08:00 - 15:00
        </button>
        <button
          className={
            DayPartitionNumber === 3
              ? "btn btn-sm btn-success"
              : "btn btn-sm btn-outline-secondary"
          }
          onClick={() => {
            handlePartitionChange(3);
          }}
        >
          16:00 - 23:00
        </button>
      </div>
    );
  };

  const MakeHeaderRow = () => {
    const headerArr = [];

    const hourStats = {};
    AppDay?.getTherapists?.forEach((therapist) => {
      therapist.getAppointmentHours?.forEach((hourData) => {
        const hr = hourData.hour;
        if (!hourStats[hr]) hourStats[hr] = {};

        const appointments = hourData.getListedAccountingSessions;

        appointments.forEach((app) => {
          if (app) {
            const type = app.getSession.category || "Session Name";
            hourStats[hr][type] = (hourStats[hr][type] || 0) + 1;
          }
        });
      });
    });

    for (let i = 0; i < DayPartitionNumber * 8; i++) {
      if (i >= (DayPartitionNumber - 1) * 8) {
        const hourString = i < 10 ? `0${i}:00` : `${i}:00`;

        const sessions = hourStats[i];
        let tooltipValue = "";

        if (sessions && Object.keys(sessions).length > 0) {
          tooltipValue = Object.entries(sessions)
            .map(([name, count]) => `${name}: ${count}`)
            .join("\n");
        } else {
          tooltipValue = "No Sessions Scheduled";
        }

        headerArr.push(
          <th
            key={i}
            className="dashed-hour-header"
            data-tooltip={tooltipValue}
          >
            {hourString}
          </th>,
        );
      }
    }
    return headerArr;
  };

  const MakeTableRow = (tDay) => {
    if (
      CurrentUser.userType === "Therapist" &&
      tDay.therapistId !== CurrentUser.getTherapist?.id
    ) {
      return null;
    }

    const appointmentHours = tDay.getAppointmentHours ?? [];

    const hasAppointments = appointmentHours.some(
      (appHour) => appHour.getAppointments?.length > 0,
    );

    const isRemoving = removingTherapist === tDay.therapistId;

    return (
      <tr key={tDay.therapistId}>
        <td
          className="sticky-col sticky-col-1"
          style={{
            backgroundColor: "#242424",
            color: "#fff",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "4px 8px",
            }}
          >
            <span style={{ flex: 1, textAlign: "left" }}>
              {tDay.therapistName}
            </span>

            {(["Admin", "Owner", "HeadAccounting"].includes(
              CurrentUser.userType,
            ) ||
              CurrentUser.userType === "AppointmentEmployee" ||
              CurrentUser.userType === "CallCenterEmployee") && (
              <div
                style={{ display: "flex", alignItems: "center", gap: "4px" }}
              >
                {hasAppointments && (
                  <Warning
                    fontSize="small"
                    style={{ color: "#f39c12" }}
                    title="Has active appointments"
                  />
                )}
                <button
                  onClick={() => removeTherapistFromDay(tDay)}
                  className={`btn btn-sm ${
                    hasAppointments ? "btn-secondary" : "btn-danger"
                  }`}
                  disabled={hasAppointments || isRemoving}
                  title={
                    isRemoving
                      ? "Removing..."
                      : hasAppointments
                        ? translations.appointmentTableCannotRemoveHasAppointments ||
                          "Cannot remove - has appointments"
                        : translations.appointmentTableRemoveTherapist ||
                          "Remove therapist from this day"
                  }
                  style={{
                    padding: "2px 6px",
                    minWidth: "28px",
                    opacity: isRemoving ? 0.6 : 1,
                    cursor:
                      hasAppointments || isRemoving ? "not-allowed" : "pointer",
                  }}
                >
                  {isRemoving ? (
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="sr-only">Loading...</span>
                    </div>
                  ) : (
                    <Delete fontSize="small" />
                  )}
                </button>
              </div>
            )}
          </div>
        </td>

        {appointmentHours
          .sort((a, b) => (a.hour > b.hour ? 1 : -1))
          .map((appHour) => {
            if (
              appHour.hourIndex < DayPartitionNumber * 8 &&
              appHour.hourIndex >= (DayPartitionNumber - 1) * 8
            ) {
              return (
                <td key={appHour.id}>
                  <AppHourCell2
                    AppDay={AppDay}
                    AppHour={appHour}
                    GetAppDayById={GetAppDayById}
                    setSelectedAppHour={setSelectedAppHour}
                    EnableFacilityModal={EnableFacilityModal}
                    EnableAppointmentModal={EnableAppointmentModal}
                    PasteSession={PasteSession}
                    setMovingSession={setMovingSession}
                    setIsLoaded={setIsLoaded}
                    Reminders={Reminders}
                    LoadReminders={GetDayReminders}
                  />
                </td>
              );
            }
            return null;
          })}
      </tr>
    );
  };

  const EnableFacilityModal = (enable, accSession) => {
    if (!enable) {
      setShowFacilityModal(false);
      return;
    }
    setFacilityAccSession(accSession);
    setShowFacilityModal(true);
  };

  const EnableAppointmentModal = (enable, appHour) => {
    if (!enable) {
      setShowCreateAppointment(false);
      return;
    }
    setSelectedAppHour(appHour);
    setShowCreateAppointment(true);
  };

  const AddSessionToAppointmentHour = (session, appHour) => {
    setAppDay((prevAppDay) => {
      return {
        ...prevAppDay,
        getTherapists: prevAppDay.getTherapists.map((th) => {
          return th.id === appHour.appointmentDayTherapistId
            ? {
                ...th,
                getAppointmentHours: th.getAppointmentHours.map((aH) =>
                  aH.id === appHour.id
                    ? {
                        ...aH,
                        getListedAccountingSessions: [
                          ...(aH.getListedAccountingSessions ?? []),
                          session,
                        ],
                      }
                    : aH,
                ),
              }
            : th;
        }),
      };
    });
  };

  return (
    <div className="app-day appDayTableCard">
      <MDBox style={{ marginLeft: ShowSideBar ? "270px" : "0px" }}>
        <div className={`header-element ${isCollapsed ? "collapsed" : ""}`}>
          <MDTypography mb={3} variant="h5" component="div">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "1.5rem",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                  flexWrap: "wrap",
                  gap: "10px",
                }}
              >
                <button
                  className="btn btn-sm btn-dark"
                  onClick={() => setShowSideBar(!ShowSideBar)}
                  style={{ height: "40px", width: "40px" }}
                >
                  {ShowSideBar ? <Icon>close</Icon> : <Icon>menu</Icon>}
                </button>

                <div
                  className="Day-date-card"
                  style={{
                    margin: 0,
                    padding: "8px 15px",
                    borderRadius: "8px",
                    fontSize: "1rem",
                    display: "flex",
                    gap: "10px",
                  }}
                >
                  <span>
                    <strong>Day:</strong>{" "}
                    {new Date(AppDay?.dateDay ?? "").toLocaleDateString(
                      "en-GB",
                    )}
                  </span>
                  <span style={{ color: "#ccc" }}>|</span>
                  <span>
                    <strong>ID:</strong> {AppDay?.id ?? ""}
                  </span>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                {[
                  "Admin",
                  "Owner",
                  "HeadAccounting",
                  "AppointmentEmployee",
                  "CallCenterEmployee",
                  "SubAdmin",
                ].includes(CurrentUser.userType) && (
                  <>
                    <button
                      className="btn btn-sm btn-outline-dark"
                      style={{
                        flex: "1 1 auto",
                        minWidth: "130px",
                        maxWidth: "200px",
                      }}
                      onClick={() => setShowAddTherapist(!ShowAddTherapist)}
                    >
                      {ShowAddTherapist
                        ? translations.appointmentTableCancelTherapist
                        : translations.appointmentTableAddTherapist}
                    </button>

                    <button
                      className="btn btn-sm btn-outline-dark"
                      style={{
                        flex: "1 1 auto",
                        minWidth: "130px",
                        maxWidth: "200px",
                      }}
                      onClick={() => setShowTransferModal(true)}
                    >
                      Move/Switch
                    </button>

                    <button
                      className="btn btn-sm btn-outline-dark"
                      style={{
                        flex: "1 1 auto",
                        minWidth: "130px",
                        maxWidth: "200px",
                      }}
                      onClick={() => setShowCopyDay(!ShowCopyDay)}
                    >
                      {ShowCopyDay
                        ? translations.appointmentTableCancelCopy
                        : translations.appointmentTableSmartCopyAnotherDay}
                    </button>

                    <button
                      className="btn btn-sm btn-outline-danger"
                      style={{
                        flex: "1 1 auto",
                        minWidth: "130px",
                        maxWidth: "200px",
                      }}
                      onClick={ClearAppointmentDay}
                    >
                      {translations.appointmentTableClearAllSessions}
                    </button>

                    <button
                      className="btn btn-sm btn-outline-info"
                      style={{
                        borderColor: "#3560AD",
                        color: "#3560AD",
                        flex: "1 1 auto",
                        minWidth: "130px",
                        maxWidth: "200px",
                      }}
                      onClick={() => setShowEvalModal(true)}
                    >
                      <Icon
                        sx={{
                          verticalAlign: "middle",
                          mr: 0.5,
                          fontSize: "1.1rem",
                        }}
                      >
                        assignment_ind
                      </Icon>
                      Evaluation
                    </button>
                  </>
                )}

                <button
                  className="btn btn-sm btn-outline-warning"
                  onClick={() => setShowDummyModal(true)}
                  disabled={dummySessionsList.length === 0}
                  style={{
                    borderColor: "#f39c12",
                    color: "#f39c12",
                    flex: "1 1 auto",
                    minWidth: "130px",
                    maxWidth: "200px",
                    opacity: dummySessionsList.length === 0 ? 0.5 : 1,
                  }}
                >
                  <Icon
                    sx={{
                      verticalAlign: "middle",
                      mr: 0.5,
                      fontSize: "1.1rem",
                    }}
                  >
                    {dummySessionsList.length === 0
                      ? "visibility_off"
                      : "visibility"}
                  </Icon>
                  Dummy ({dummySessionsList.length})
                </button>
                <button
                  className="btn btn-sm btn-outline-dark"
                  style={{
                    flex: "1 1 auto",
                    minWidth: "130px",
                    maxWidth: "200px",
                  }}
                  onClick={() => setIsOrderModalOpen(true)}
                >
                  Reorder Therapists
                </button>
              </div>
              {[
                "Admin",
                "Owner",
                "HeadAccounting",
                "AppointmentEmployee",
                "CallCenterEmployee",
                "SubAdmin",
              ].includes(CurrentUser.userType) && (
                <div
                  style={{
                    display: "flex",
                    gap: "5px",
                    width: "100%",
                    maxWidth: "450px", // Limits width so it looks "centered" and clean
                    justifyContent: "center",
                    backgroundColor: "#ffffff",
                    padding: "5px",
                    borderRadius: "10px",
                  }}
                >
                  <div style={{ flexGrow: 1 }}>
                    <MDInput
                      fullWidth
                      className={
                        translations.setlang === "ar" ? "rtl-label" : ""
                      }
                      onChange={(e) => setSearchString(e.target.value)}
                      label={translations.appointmentTablesearchappointments}
                      size="small"
                    />
                  </div>
                  <MDButton
                    onClick={onSearch}
                    sx={{
                      height: "30px",
                      minWidth: "50px",
                      backgroundColor: "#3560AD",
                      "&:hover": { backgroundColor: "#4682B4" },
                    }}
                    color="info"
                  >
                    <Icon sx={{ fontWeight: "bold" }}>search</Icon>
                  </MDButton>
                </div>
              )}
            </div>
          </MDTypography>
          <MDBox mt={-2}>{GetDayPartitionButtons()}</MDBox>

          <MDBox>
            <div className="zoom-controls">
              <button onClick={handleZoomOut} variant="gradient" color="info">
                <ZoomOut sx={{ width: "25px", height: "25px" }} />
              </button>
              <button
                onClick={handleZoomIn}
                variant="gradient"
                color="info"
                sx={{ marginLeft: "8px" }}
              >
                <ZoomIn sx={{ width: "25px", height: "25px" }} />
              </button>
            </div>
          </MDBox>
          <button className="collapse-btn" onClick={toggleHeader}>
            {isCollapsed ? <Icon>expand_more</Icon> : <Icon>expand_less</Icon>}
          </button>
        </div>

        {ShowCopyDay && (
          <MDBox mt={3}>
            <CopyDayCard
              CurrentDay={AppDay}
              setAppDay={setAppDay}
              GetAppDayById={GetAppDayById}
            />
          </MDBox>
        )}
        {ShowAddTherapist && (
          <AddTherapistToDay
            AppDay={AppDay}
            GetAppDayById={GetAppDayById}
            setIsLoaded={setIsLoaded}
          />
        )}
      </MDBox>

      {isInnerLoaded ? (
        <div
          className="table-container"
          style={{
            marginLeft: ShowSideBar ? "270px" : "0px",
          }}
        >
          <table
            id="AppointmentMainTable"
            className="table table-bordere fixed-table"
            style={{
              zoom: `${zoomLevel}`,
              transformOrigin: "top left",
            }}
          >
            <thead>
              <tr className="small-width text-center">
                <th>Name / Time</th>
                {MakeHeaderRow().map((r, index) => r)}
              </tr>
            </thead>
            <tbody className="small-width text-center font-weight-bold">
              {(AppDay?.getTherapists ?? []).map((tDay) => MakeTableRow(tDay))}
            </tbody>
          </table>
        </div>
      ) : (
        <Loader />
      )}
      <AddFacilityModal
        setIsLoaded={setIsLoaded}
        ShowModal={ShowFacilityModal}
        AccSession={FacilityAccSession}
        EnableModal={EnableFacilityModal}
      />
      <CreateAppointmentPopUp
        AppDay={AppDay}
        setAppDay={setAppDay}
        GetAppDayById={GetAppDayById}
        AppHour={SelectedAppHour}
        ShowCreateAppointment={ShowCreateAppointment}
        EnableModal={EnableAppointmentModal}
        DayPartitionNumber={DayPartitionNumber}
        AddSession={AddSessionToAppointmentHour}
      />
      <TherapistDetailsPopUp
        show={showTransferModal}
        onClose={() => setShowTransferModal(false)}
        therapists={AppDay?.getTherapists}
        appDayId={AppDay?.id}
        setIsLoaded={setIsLoaded}
      />
      <EvalPatientsModal
        open={showEvalModal}
        onClose={() => setShowEvalModal(false)}
        AppDay={AppDay}
      />
      <DummySessionsModal
        open={showDummyModal}
        onClose={() => setShowDummyModal(false)}
        dummySessions={dummySessionsList}
      />
      <TherapistReorderModal
        open={isOrderModalOpen}
        handleClose={() => setIsOrderModalOpen(false)}
        therapists={AppDay.getTherapists}
        dayId={AppDay.id}
        refreshData={GetAppDayById}
      />
      {/*  <div
        className="patient-suggestion"
        style={{ marginLeft: ShowSideBar ? "250px" : "0px" }}
      >
        <PatientSuggestions />
      </div> */}
    </div>
  );
};

export default AppDayTableSimple;
